import React from "react";

import Form from "./form";
import ClientList from "./client/list";
import ClientShow from "./client/show";
import VendorList from "./vendor/list";
import VendorShow from "./vendor/show";

import { Switch, Route } from "react-router-dom";

import {
    LAYOUT_FINANCE_PAYMENT_VENDOR_LIST,
    LAYOUT_FINANCE_PAYMENT_VENDOR_SHOW,
    LAYOUT_FINANCE_PAYMENT_VENDOR_NEW,
    LAYOUT_FINANCE_PAYMENT_CLIENT_LIST,
    LAYOUT_FINANCE_PAYMENT_CLIENT_SHOW,
    LAYOUT_FINANCE_PAYMENT_CLIENT_NEW,
} from "../navigation";

const Router = (props) => (
    <Switch>
        <Route
            path={LAYOUT_FINANCE_PAYMENT_CLIENT_NEW(":clientId?")}
            render={(routeProps) => <Form alta paymentClient {...props} {...routeProps} />}
        />
        <Route
            path={LAYOUT_FINANCE_PAYMENT_CLIENT_LIST}
            render={(routeProps) => <ClientList {...props} {...routeProps} />}
        />
        <Route
            path={LAYOUT_FINANCE_PAYMENT_CLIENT_SHOW(":id")}
            render={(routeProps) => <ClientShow {...props} {...routeProps} />}
        />
        <Route
            path={LAYOUT_FINANCE_PAYMENT_VENDOR_NEW(":vendorId?")}
            render={(routeProps) => <Form alta {...props} {...routeProps} />}
        />
        <Route
            path={LAYOUT_FINANCE_PAYMENT_VENDOR_LIST}
            render={(routeProps) => <VendorList {...props} {...routeProps} />}
        />
        <Route
            path={LAYOUT_FINANCE_PAYMENT_VENDOR_SHOW(":id")}
            render={(routeProps) => <VendorShow {...props} {...routeProps} />}
        />
    </Switch>
);

export default Router;
